module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row lobby-article"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.article.loading),
      expression: "!article.loading"
    }],
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "article-body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.article.loading),
      expression: "article.loading"
    }],
    staticClass: "col-xs-12 text-center mv40"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-3x fa-fw"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-54b31337"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/article/widget/ArticleView.vue
// module id = 984
// module chunks = 1